import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { catchError, of, throwError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { environment } from '../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const dialog = inject(MatDialog)

  const clonedRequest = req.clone({
    withCredentials: true,
  });

  return next(clonedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && authService.isLoggedIn()) {
        console.log('In interceptor: is logged in = ', authService.isLoggedIn());

        const dialogRef = dialog.open(DialogComponent,
          {
            width: '500px',
            data: {
              dialogTitle: 'Session expired',
              content: 'Your session has expired. Please log in again.',
              newButton: false,
              createFile: false
            }
          }
        );

        dialogRef.afterClosed().subscribe(result => {
          if (!environment.production) {
            console.log(result);
          }
          router.navigate(['/sign-in']);
          authService.setAuthenticate(false);
        });

        return of();
      }

      return throwError(() => error);
    })
  );
};

